import { createElement as rc } from 'react';
import { useTheme } from 'styled-components';
import { SubMenu, MenuItem } from '../menuSelection';

/**
 * @typedef {Object} Props
 */
/** @type {import('react').FC<Props>} */
function ThemeSelector() {
    const theme = useTheme();

    const { selectedTheme, selectTheme, availableThemes } = theme;

    // prettier-ignore
    return rc(SubMenu, { key: 'themeSelector', hNode: { title: 'Switch Theme', iconName : 'figma' } },
        availableThemes.map(({ id, title }) =>
            rc(MenuItem, {
                hNode: { title},
                key: id,
                onClick: () => selectTheme(id),
                disabled: selectedTheme === id
            })
        )
    );
}

ThemeSelector.defaultProps = {};

ThemeSelector.propTypes = {};

export default ThemeSelector;
